<template>
  <div class="footer-container">
    <div
      :class="{ active: activeIndex === 0 }"
      @click="$router.push({ name: 'Home' })"
    >
      <!-- <i class="fa fa-home fa-fw"></i> -->
       <span  class="footer-icon home"></span>
      <span>{{ $t("nav.home") }}</span>
    </div>
    <div
      :class="{ active: activeIndex === 1 }"
      @click="$router.push({ name: 'Faq' })"
    >
             <span  class="footer-icon faq"></span>
      <span>{{ $t("nav.faq") }}</span>
    </div>
    <!-- <div :class="{'active':activeIndex === 2}" @click="$router.push('./Faq')">Email</div> -->
    <div :class="{ active: activeIndex === 3 }" @click="selLanguage">
             <span  class="footer-icon language"></span>
      <span>{{ $t("nav.language") }}</span>
    </div>
    <div
      v-if="!isInOmniSDK"
      :class="{ active: activeIndex === 4 }"
      @click="logout"
    >
             <span  class="footer-icon logout"></span>
      <span> {{ $t("nav.signOut") }}</span>
    </div>
   <language ref="languageRef"></language>
  </div>
</template>
<script>
import { Indicator } from "mint-ui";
import language  from "./language.vue";

export default {
  data() {
    return {
 
    };
  },
  components:{language},
  props: {
    activeIndex: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    isInOmniSDK: () => {
      return !!window._omnisdk;
    },
  },
  methods: {
    changeLang({ value }) {
      const _this = this
      localStorage.setItem("locale", value);
      _this.lang = value;
      _this.sheetVisible = false;
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    selLanguage(){
       const _this = this
      _this.$emit('showLanguage')
    },
    logout() {
       const _this = this
      Indicator.open();
      _this.$cookie.remove("token");
      sessionStorage.clear();
      _this.$store.state.canCancel = false;
      _this.$store.state.taskExist = false;
      _this.$store.state.dataExist = false;
      _this.$store.state.pendFlag = false;
      _this.$store.state.lastCancelTime = 0;
      _this.$store.state.gameID = 0;
      _this.$store.state.gameName = "";
      _this.$store.state.aid = "";
      _this.$store.state.pin = "";
      _this.$store.state.icon = "";
      _this.$store.state.serviceMail = "";
      // 清除各种缓存
      let lockParam =``
      if(localStorage.screenLock){
        lockParam= `?${localStorage.screenLock}=true`
      }
      setTimeout(() => {
        _this.$router.push(`/${lockParam}`);
        Indicator.close();
      }, 500);
    },
  },
};
</script>
<style lang="less" scoped>
.footer-container {
  width: 100%;
  flex-basis: 20%;
  flex-shrink: 0;
  flex-grow: 1;
  -webkit-flex-grow: 1;
  -webkit-justify-content: center;
  -webkit-align-items: center;
  justify-content: center;
  align-items: center;
  display: flex;
  display: -webkit-flex;
  height: 1.5rem;
  color: #fff;
  background-color: #1C2532 ;
  transition: all 0.3s ease;
  position: fixed;
  bottom: 0;
  left: 0;
  // 
  padding-bottom: 0.9rem;
  div {
    flex: 1;
    height: 1.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    height: 100%;
    color: #9DA2B2 ;
    // font-size: 0.26rem;
    .footer-icon{
      width: 0.85rem;
      height: 0.85rem;
      &.home{
        background: url('../../assets/foot/home.png') center center no-repeat;
        background-size: 100% 100%;
      }
      &.faq{
        background: url('../../assets/foot/FAQ.png') center center no-repeat;
        background-size: 100% 100%;
      }
      &.language{
        background: url('../../assets/foot/language.png') center center no-repeat;
        background-size: 100% 100%;
      }
      &.logout{
        background: url('../../assets/foot/logout.png') center center no-repeat;
        background-size: 100% 100%;
      }

    }
    i {
      width: 100%;
      display: block;
      font-size: 0.65rem;
    }
    span {
      display: block;
      text-align: center;
      font-size: 0.293rem;
      font-weight: 700;
    }

    &.active {
      background: #3C495C  !important;
      color: #ffffff;
          .footer-icon.home{
            background: url('../../assets/foot/home_active.png') center center no-repeat;
            background-size: 100% 100%;
          }
            .footer-icon.faq{
            background: url('../../assets/foot/FAQ_active.png') center center no-repeat;
            background-size: 100% 100%;
          }
          .footer-icon.language{
            background: url('../../assets/foot/language_active.png') center center no-repeat;
            background-size: 100% 100%;
          }
          .footer-icon.logout{
            background: url('../../assets/foot/logout_active.png') center center no-repeat;
            background-size: 100% 100%;
          }

    }
    
  }
}

@media screen and (orientation: landscape) {
  .footer-container{
     padding-bottom:  0.4rem;
  }

.footer-container div{
  flex-direction: row;
  gap: 0.32rem;
  div{
    padding-bottom: 0 ;
  }
  span{
    font-size: 0.42rem;
  }
}
}
</style>
